import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for email list targetables
 */
export interface IEmailListTargetable extends ITargetableBase {
  _cls: TargetableClass.email_list;
  list_file_name: string;
  list_file: string;
  num_unique_emails: number;
}

/**
 * EmailListTargetable class for email list targetables
 */
export class EmailListTargetable extends TargetableBase<IEmailListTargetable> {
  public override className = 'Targetable.EmailListTargetable';

  public override getDefaults(): Partial<IEmailListTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.email_list,
    };
  }

  public override get constraints(): TConstraints<IEmailListTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.email_list],
      },
      list_file: {
        presence: {
          allowEmpty: false,
          message: '^Target does not have a list.',
        },
      },
    };
  }
}
